import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CheckOutService } from '../CheckOut.service';
import { CheckOutActions } from '../CheckOutActions';

@Component({
  selector: 'app-paid-list',
  templateUrl: './paid-list.component.html'
})
export class PaidListComponent extends CheckOutActions implements OnInit {

  @Input() orderDetails!: any;
  printRecipt = false;
  printCheckOutId!: any;

  @Input() showActions = true;

  constructor(
    checkoutService: CheckOutService,
    translate: TranslateService,
  ) { super(checkoutService, translate) }

  ngOnInit(): void {
    // if (this.orderDetails) {
    //   this.currentOrderId = this.orderDetails.orderId;
    //   this.currency = this.orderDetails.currency;
    // }
  }

  ngOnChanges(changes: any): void {
    if (changes.orderDetails) {
      this.currentOrderId = this.orderDetails.orderId;
      this.currency = this.orderDetails.currency;
    }
  }

  printReady() {
    this.printRecipt = false;
    this.printCheckOutId = false;
  }

}
